module.exports = __webpack_public_path__ + "img/photo-0023.46402edf.jpg";